import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { BehaviorSubject, Observable } from 'rxjs';
import { Forgot } from './forgot.model';

@Injectable()
export class ForgotService {
      public data: Forgot;
      lifeInsurance: boolean;
      type: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
      userType: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
      uid: BehaviorSubject<string> = new BehaviorSubject<string>(undefined);
      quesIndex: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(undefined);
      questions: BehaviorSubject<string[]> = new BehaviorSubject<string[]>(undefined);
      constructor(private httpclient: HttpClient) { }

      // calls pwd service for client
      getPassword(bodyString: string) {
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/getPwd', bodyString, { headers }).map(resp => resp);
      }

      // calls pwd service for broker
      getBrokerPassword(dob: string, ssn: string, userType: string, pasted: string, selectedOption: string) {
            const bodyString = JSON.stringify({ dob, ssn, userType, pasted, selectedOption });
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/getPwd', bodyString, { headers }).map(resp => resp);
      }


      // call uid service
      getUserId(json: string) {
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/getUid', json, { headers }).map(resp => resp);
      }

      validateAns(answer: string[], question: string[], userType: string, quesIndex: string[]) {
      		let bodyString = JSON.stringify({ answer, question, userType, quesIndex });       
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/validateAns', bodyString, { headers }).map(resp => resp);
      }

      uidAns(answer: string[], question: string[]) {
            const bodyString = JSON.stringify({ answer, question });
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/uidAns', bodyString, { headers }).map(resp => resp);
      }

      // update password for client
      updatePass(password: string, userType: string) {
            const bodyString = JSON.stringify({ password, userType });
            const headers = new HttpHeaders({ 'Content-Type': 'application/JSON' });
            return this.httpclient.post<Forgot>('/forgot/updatePass', bodyString, { headers }).map(resp => resp);
      }

      getType(): Observable<string> {
            return this.type.asObservable();
      }

      setType(type: string) {
            this.type.next(type);
      }

      getUserType(): Observable<string> {
            return this.userType.asObservable();
      }

      setUserType(userType: string) {
            this.userType.next(userType);
      }

      getQuestions(): Observable<string[]> {
            return this.questions.asObservable();
      }

      setQuestions(questions: string[]) {
            this.questions.next(questions);
      }

      setUid(uid: string) {
            this.uid.next(uid);
      }

      getUid(): Observable<string> {
            return this.uid.asObservable();
      }
      
      setQuesIndex(quesIndex: string[]) {
            this.quesIndex.next(quesIndex);
      }

      getQuesIndex(): Observable<string[]> {
            return this.quesIndex.asObservable();
      }
      
      getNativeWindow() {
            return window;
      }
}
